import { isEmpty } from 'lodash'

import extractChoiceText from './extract-choice-text'
import extractMiscText from './extract-misc-text'

const containsMiscOrChoiceText = text =>
  !isEmpty(extractChoiceText(text)) || !isEmpty(extractMiscText(text))

export default containsMiscOrChoiceText
